import { Nav, Container, NavDropdown, Row, Col, Navbar } from 'react-bootstrap';
import { useNavigate, Link } from "react-router-dom";
import { useContext } from "react";

import { ClienteContext } from "../../services/ClienteContext";
import "./styles.css";
import NotificationsAlert from '../../services/NotificationsAlert';
import Logo from '../../assets/Logo 300x300.png'

const Header = () => {

  const cliente = useContext(ClienteContext);
  const history = useNavigate();
  const idUser = localStorage.getItem('resid')
  const nameUser = localStorage.getItem('resfirstName')
  const lastNameUser = localStorage.getItem('reslastName')

  const loginLogout = () => {
    cliente.setDados({ id: null, nome: "", token: "" });
    localStorage.clear()
    history("/login")
    let message = "Até breve!"
    NotificationsAlert("default", message, "")
  }

  let user;
  if (cliente.dados.user_id || idUser) {
    user = (
      <>
        <text className="btn" style={{ color: '#fff' }}>Olá {`${nameUser} ${lastNameUser}`} <i className="fas fa-sign-out-alt" /></text>
      </>
    )
  } else {
    user = (
      <>
        <text className="btn" style={{ color: '#fff' }}>Entrar <i className="fas fa-sign-in-alt"></i></text>
      </>
    )
  }

  return (
    <Navbar expand="lg" id='nav' className="navbar-dark">
      <Container>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Row className="justify-content-around align-items-center w-100" style={{ marginTop: "-1.5%", marginBottom: "-1.5%" }}>
            <Col xs="auto" id='home'>
              <Link className="navbar-brand" to="/gestoria">
                <img src={Logo} style={{ width: "80px", marginRight: "2%" }} alt="Sakamotto Server Logo" />
                <text style={{ color: '#fff' }}>Sakamotto Sistema</text>
              </Link>
            </Col>
            <Col xs="auto" className="text-center mt-2 mt-md-0">
                <Link to="/home" style={{ color: '#fff' }}>Portal</Link>
              <Nav className="me-auto">


                <NavDropdown style={{ color: '#fff' }} title={<text style={{ color: '#fff' }}>Cadastros</text>} id="basic-nav-dropdown" >
                  <div style={{ backgroundColor: '#4c3971', marginTop: -10, marginBottom: -10 }}>
                    <NavDropdown.Item style={{ backgroundColor: '#4c3971' }}>
                      <Link to="/chipmanager" style={{ color: '#fff' }}>Chips</Link>
                    </NavDropdown.Item>
                    <NavDropdown.Item style={{ backgroundColor: '#4c3971' }}>
                      <Link to="/clientmanager" style={{ color: '#fff' }}>Clientes</Link>
                    </NavDropdown.Item>
                    <NavDropdown.Item style={{ backgroundColor: '#4c3971' }}>
                      <Link to="/equipmanager" style={{ color: '#fff' }}>Equipamentos</Link>
                    </NavDropdown.Item>
                    <NavDropdown.Item style={{ backgroundColor: '#4c3971' }}>
                      <Link to="/positions" style={{ color: '#fff' }}>Motoristas</Link>
                    </NavDropdown.Item>
                    <NavDropdown.Item style={{ backgroundColor: '#4c3971' }}>
                      <Link to="/apnmanager" style={{ color: '#fff' }}>Operadoras</Link>
                    </NavDropdown.Item>
                    <NavDropdown.Item style={{ backgroundColor: '#4c3971' }}>
                      <Link to="/workpoint" style={{ color: '#fff' }}>Usuario</Link>
                    </NavDropdown.Item>
                    <NavDropdown.Item style={{ backgroundColor: '#4c3971' }}>
                      <Link to="/vehiclesmanager" style={{ color: '#fff' }}>Veiculos</Link>
                    </NavDropdown.Item>
                  </div>
                </NavDropdown>

                <NavDropdown style={{ color: '#fff' }} title={<text style={{ color: '#fff' }}>Sistema</text>} id="basic-nav-dropdown" >
                  <div style={{ backgroundColor: '#4c3971', marginTop: -10, marginBottom: -10 }}>
                    <NavDropdown.Item style={{ backgroundColor: '#4c3971' }}>
                      <Link to="/workpoint" style={{ color: '#fff' }}>Acesso</Link>
                    </NavDropdown.Item>
                    <NavDropdown.Item style={{ backgroundColor: '#4c3971' }}>
                      <Link to="/positions" style={{ color: '#fff' }}>Operadoras</Link>
                    </NavDropdown.Item>
                    <NavDropdown.Item style={{ backgroundColor: '#4c3971' }}>
                      <Link to="/positions" style={{ color: '#fff' }}>Tipos de Veiculos</Link>
                    </NavDropdown.Item>
                  </div>
                </NavDropdown>

              </Nav>
            </Col>
            <Col xs="auto" className="text-end">
              <Link to="/login" onClick={loginLogout} style={{ color: '#fff' }}>
                {user}
              </Link>
            </Col>
          </Row>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};



export default Header;